import { getDocumentData } from "@alethea-medical/utilities";
import { User } from "../../shared/types";
import db from "../firebase/db";


function getProfile(uid: string): Promise<User> {
    return db.collection("users").doc(uid).get().then(getDocumentData)
}

export default getProfile;